import { variablePattern, wildCardPattern } from '../constants';
var REGEX_FOR_SPECIAL_CHARS = /[.*+?^$()|]/g;
export var getMappingRegex = function (mapping) {
    var mappingWithWildCards = mapping
        .replace(REGEX_FOR_SPECIAL_CHARS, '\\$&')
        .replace(new RegExp(variablePattern, 'g'), wildCardPattern);
    return RegExp("^".concat(mappingWithWildCards, "$"));
};
//# sourceMappingURL=get-mapping-regex.js.map